import EventSpace2ContentTop from './EventSpace2ContentTop'
import EventSpace2InteractionsGrouped from './EventSpace2InteractionsGrouped'
import EventSpace2DwellTimeline from './EventSpace2DwellTimeline'
import EventSpace2StoresTop from './EventSpace2StoresTop'
import EventSpace2DevicesOnline from './EventSpace2DevicesOnline'

const EventSpace2Reducers = [
  EventSpace2ContentTop,
  EventSpace2InteractionsGrouped,
  EventSpace2DwellTimeline,
  EventSpace2StoresTop,
  EventSpace2DevicesOnline
]

export default EventSpace2Reducers
